import React from "react";
import MightyInput from "mighty-input";

import "./style.css";

export function FixedInputValue({ value = "", onlyValue = "", ...props }) {
  // Fix value
  const filter = (next, prev) => (onlyValue.startsWith(next) ? next : prev);

  // Render unprinted part of value in other colour
  const render = next => {
    if (next === onlyValue) {
      return next;
    } else {
      return (
        <>
          <span className="fixedInputValue-head">{next}</span>
          <span className="fixedInputValue-tail">
            {onlyValue.slice(next.length)}
          </span>
        </>
      );
    }
  };

  return (
    <MightyInput
      value={value}
      className="myInput"
      filter={filter}
      render={render}
      {...props}
    />
  );
}
